import { GridColDef } from '@mui/x-data-grid';

import DataGridBlankLabel from '../../../shared/components/ui/datagrid/datagrid-blank-label';

export const columns: GridColDef[] = [
  {
    field: 'signatory',
    headerName: 'Signatory',
    flex: 1,
    disableColumnMenu: true,
  },
  {
    field: 'signatory_email',
    headerName: 'Email',
    flex: 1,
    disableColumnMenu: true,
  },
  {
    field: 'department',
    headerName: 'Department',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.department);
    },
  },
  {
    field: 'position',
    headerName: 'Position',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.position);
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    disableColumnMenu: true,
  },
  {
    field: 'approved_at',
    headerName: 'Approved Date',
    flex: 1,
    disableColumnMenu: true,
  },
  {
    field: 'day_processed',
    headerName: 'No. of days Proccess',
    flex: 1,
    disableColumnMenu: true,
  },
  {
    field: 'remarks',
    headerName: 'Remarks',
    flex: 1,
    disableColumnMenu: true,
  },
];
